import { type FC, useEffect } from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../globaltypes/redux";
import dataService from "../services/dataServices/typedDataService";

export const ChameleonProvider: FC<PropsFromRedux> = ({ userId, accountId, accountTypeId, packIds, tags }) => {
  useEffect(() => {
    if (!window.chmln) {
      return;
    }

    const addChameleon = async () => {
      const { data } = await dataService.users.getUserSigningSecret();
      window.chmln.identify(userId, {
        accountId,
        accountTypeId,
        packIds,
        tags,
        uid_hash: data,
        company: {
          uid: accountId,
        },
      });
    };

    addChameleon();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  userId: state.userProfile.id,
  accountId: state.userProfile.accountId,
  accountTypeId: state.userProfile.accountTypeId,
  packIds: state.userProfile.packIds,
  tags: state.userProfile.tags,
});

const connector = connect(mapStateToProps, {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(ChameleonProvider);
export default ConnectedComponent;
